module.exports = __webpack_public_path__ + "static/media/v2-50.0720d494.webp";